
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnBOMGrid extends Serenity.EntityGrid<CertificationReturnBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.CertificationReturnBOM'; }
        protected getDialogType() { return CertificationReturnBOMDialog; }
        protected getIdProperty() { return CertificationReturnBOMRow.idProperty; }
        protected getInsertPermission() { return CertificationReturnBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationReturnBOMRow.localTextPrefix; }
        protected getService() { return CertificationReturnBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}